import { ListMenuItem } from "@compass/core";
import { Permission, PermissionAction } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import {
  StudentGroupBulkUpdatePageState,
  studentGroupBulkUpdatePageRoute,
} from "../StudentGroupBulkUpdatePage/StudentGroupBulkUpdatePage";

export const useStudentGroupListMenuItems = (props: { permission: Permission }) => {
  const navigate = useNavigate();
  const menuItems: ListMenuItem[] = [];

  if (isAuthorized(props.permission, PermissionAction.Update))
    menuItems.push({
      label: "Update",
      action: (selectedIds: number[]) =>
        navigate(studentGroupBulkUpdatePageRoute.getPath(), {
          state: { selectedIds: selectedIds } as StudentGroupBulkUpdatePageState,
        }),
    });

  return menuItems;
};
